import { Component, Input, OnInit } from '@angular/core';

import { EmpowerModernLifeService } from 'src/services/empower-services/empower-modern-life.service';
import { EmpowerExportService } from 'src/services/empower-services/empower-export.service';
import { generateTitleDiv, NO_IMAGE, undefinedImagePath } from 'src/modules/empower-module/helper';

@Component({
  selector: 'empower-m365-consumer-jour-touchpoints',
  templateUrl: './m365-consumer-jour-touchpoints.component.html',
  styleUrls: ['./m365-consumer-jour-touchpoints.component.scss']
})
export class EmpowerM365ConsumerJourTouchpointsComponent implements OnInit {

  @Input() data: any;
  // ../assets/empower/pitch-factory/images/24-screen-01.png
  imageUrl = NO_IMAGE;
  innerHtml = '';

  constructor(public empowerModernLifeService: EmpowerModernLifeService, private empowerExportService: EmpowerExportService) { }

  ngOnInit(): void {
    if (this.data) {
      this.data = JSON.parse(this.data);
      this.checkPageState(this.data.pageId);
    }
  }

  checkPageState(pageId) {
    const imageUrl = this.empowerModernLifeService.getPageImgState(pageId);
    if (imageUrl) {
      this.imageUrl = imageUrl;
    }
    if (this.imageUrl == NO_IMAGE) this.emitExportEvent(null);

    this.innerHtml = generateTitleDiv(this.data);
  }

  imageChange(imageUrl) {
    this.empowerModernLifeService.setPageImgState(this.data.pageId, imageUrl);
  }

  emitExportEvent(resolvedState: boolean) {
    setTimeout(() => {
      this.data && this.data.export && this.empowerExportService.setExportComponentSubject(24, resolvedState, this.data.pageIndex, this.data.pageTitle);
    }, 1000);
  }

}
